import { render, staticRenderFns } from "./u-tit-dot.vue?vue&type=template&id=ae6a4f5e&scoped=true&"
import script from "./u-tit-dot.vue?vue&type=script&lang=js&"
export * from "./u-tit-dot.vue?vue&type=script&lang=js&"
import style0 from "./u-tit-dot.vue?vue&type=style&index=0&id=ae6a4f5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae6a4f5e",
  null
  
)

export default component.exports